module.exports = __webpack_public_path__ + "img/bg_avatar_male_45.569cf041.png";